import { render, staticRenderFns } from "./GroupCreateModal.vue?vue&type=template&id=7bb46ca4"
import script from "./GroupCreateModal.vue?vue&type=script&lang=js"
export * from "./GroupCreateModal.vue?vue&type=script&lang=js"
import style0 from "./GroupCreateModal.vue?vue&type=style&index=0&id=7bb46ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports